{
    "accessInstructions": {
        "connecting": "Connexion aux serveurs...",
        "joinSession": "Rejoindre la session",
        "loadingMedia": "Chargement du flux vidéo...",
        "useMachine": "Utiliser mon Cloud PC"
    },
    "common": {
        "action": {
            "acknowledge": "C'est noté !",
            "cancel": "Annuler",
            "captureCursor": "Capturer le curseur",
            "close": "Fermer",
            "connect": "Connecter",
            "createGroupSession": "Créer une session de groupe",
            "disable": "Désactiver",
            "disconnect": "Déconnecter",
            "downloadUsbAgent": "Télécharger l'agent USB (Windows x64)",
            "downloadUsbAgentUpdate": "Télécharger la mise à jour de l'agent USB",
            "enableWebcam": "Activer la webcam",
            "endSession": "Terminer la session",
            "exclude": "Exclure",
            "exit": "Quitter",
            "exitFullscreen": "Quitter le plein écran",
            "fold": "Replier",
            "freeCursor": "Libérer le curseur",
            "giveControlTo": "Donner le contrôle à {user}",
            "joinSupervisionRoom": "Rejoindre une salle de supervision",
            "keepControl": "Garder le contrôle",
            "keepSessionOpen": "Garder ma session ouverte",
            "loading": "Chargement...",
            "manageGroupSession": "Gérer la session de groupe",
            "measure": "Mesurer",
            "ok": "Ok",
            "putMachineInSleepMode": "Mettre en veille mon Cloud PC",
            "quitSession": "Quitter la session",
            "reconnect": "Relancer la connexion",
            "requestControl": "Demander le contrôle",
            "restart": "Redémarrer",
            "restartUpdateDetection": "Relancer la détection",
            "retryConnection": "Réessayer la connexion",
            "returnToSupervisionRoom": "Retourner vers la salle de supervision",
            "send": "Envoyer",
            "showDebug": "Afficher le debug",
            "showMenu": "Afficher le menu",
            "showTips": "Afficher les conseils",
            "startTest": "Démarrer test",
            "stop": "Arrêter",
            "suspend": "Mettre en veille",
            "takeControlByForce": "Prendre le contrôle de force",
            "understood": "J'ai compris",
            "unenrollFromSupervisionRoom": "Quitter la salle de supervision",
            "unfold": "Déplier",
            "unlock": "Déverrouiller",
            "validate": "Valider"
        },
        "error": {
            "unexpected": "Une erreur imprévue est survenue. Merci de contacter le support si l'erreur persiste.",
            "validation": "Des champs invalides ont été détectés."
        },
        "label": {
            "acceptableDelay": "Délai acceptable",
            "agentConnected": "Agent connecté",
            "androidControlPanelInstructions": "Instructions du panneau de contrôle Android",
            "audio": "Audio",
            "autoDisconnect": "Déconnexion automatique en cas d'inactivité (20 minutes)",
            "averageVideoBitrate": "Débit moyen de la vidéo",
            "backspace": "Retour arrière",
            "bandwidth": "Bande passante",
            "bitsReceived": "Bits reçus",
            "bytes": "octets",
            "changeRequest": "Demande de changement",
            "commercial": "Commercial",
            "configuration": "Configuration",
            "connectedTo": "Connecté à {room}",
            "controlPanel": "Panneau de contrôle",
            "customCommand": "Commande personnalisée",
            "debugLocalCapture": "Debug (capture locale)",
            "defaultUser": "Utilisateur par défaut",
            "delete": "Suppr",
            "description": "Description",
            "display": "Affichage",
            "duration": "Durée",
            "fast": "Rapide",
            "fileTooLarge": "Fichier trop volumineux",
            "fileTransfer": "Transfert de fichiers",
            "fps": "FPS",
            "fpsOptimization": "Optimisation vidéo (FPS)",
            "framesDropped": "Images perdues",
            "fullscreen": "Plein écran",
            "fullscreenMode": "Mode plein écran",
            "general": "Général",
            "groupSessionLink": "Lien vers votre session de groupe",
            "host": "Hôte",
            "incident": "Incident",
            "interaction": "Interaction",
            "interactionLatency": "Latence d'interaction",
            "iosFullscreenInstructions": "Instructions de plein écran iOS",
            "ipv4Address": "Adresse IPv4",
            "ipv6Address": "Adresse IPv6",
            "jitter": "Gigue",
            "kb": "Ko",
            "latency": "Latence",
            "live": "Live",
            "localResolution": "Résolution locale",
            "macAddress": "Adresse MAC",
            "machineLocked": "Cloud PC verrouillé",
            "mb": "Mo",
            "mbPerSecond": "Mo/s",
            "metricsPanel": "Panneau métriques",
            "metricsPanelDisplay": "Affichage panneau métriques",
            "mouseFunctionality": "Fonctionnalité de la souris",
            "mouseWheelScrollSensitivity": "Sensibilité scroll molette",
            "name": "Nom",
            "network": "Réseau",
            "normal": "Normal",
            "other": "Autre",
            "owner": "Propriétaire",
            "packetsLate": "Paquets en retard",
            "packetsLost": "Paquets perdus",
            "packetsReceived": "Paquets reçus",
            "participantList": "Liste des participants",
            "password": "Mot de passe",
            "preconfiguredShortcuts": "Raccourcis préconfigurés",
            "pressKeys": "Appuyez sur les touches...",
            "problem": "Problème",
            "problemDetected": "Problème detecté",
            "remoteResolution": "Résolution distante",
            "resolution": "Résolution",
            "results": "Résultats",
            "seconds": "secondes",
            "server": "Serveur",
            "settings": "Paramètres",
            "sharingInProgress": "Partage en cours",
            "sideMenu": "Menu latéral",
            "sideMenuBurgerButtonDisplay": "Affichage bouton burger menu",
            "sideMenuShortcut": "Raccourci menu latéral",
            "slow": "Lent",
            "spiceDriver": "Driver Spice VDAgent",
            "supervisedBy": "Supervisé par {supervisor}",
            "timeRemaining": "Temps restant : {0}",
            "totalDataConsumption": "Consommation totale de données",
            "transferError": "Erreur de transfert",
            "transferSuccess": "Transfert réussi",
            "type": "Type",
            "updateAvailable": "Mise à jour disponible",
            "upscaleMode": "Mode upscale",
            "usbAgentConnectionError": "Échec de connexion à l'agent local",
            "usbAgentDisconnected": "Agent déconnecté",
            "usbAgentError": "Une erreur est survenue",
            "usbAgentGuiDisconnected": "Êtes-vous connecté à l'Agent Weytop ?",
            "usbAgentUpdateDetected": "Agent mis à jour",
            "usbAgentUpdateNotDetected": "Mise à jour non détectée",
            "usbDeviceConnected": "Périphérique connecté",
            "usbDeviceDisconnected": "Périphérique déconnecté",
            "usbDeviceError": "Erreur de connexion du périphérique",
            "usbDevicePending": "Périphérique en cours de connexion",
            "usbDevices": "Périphériques USB (Beta)",
            "user": "Utilisateur",
            "userRequest": "Demande utilisateur",
            "userReturn": "Retour utilisateur",
            "veryFast": "Très rapide",
            "verySlow": "Très lent",
            "video": "Vidéo",
            "videoQuality": "Qualité vidéo",
            "videoQualityLow": "Basse (180p)",
            "webcam": "Webcam",
            "webcamConnected": "Webcam connectée",
            "windowed": "Fenêtré"
        },
        "sentence": {
            "androidMachinesRequireTouchDevice": "Nos Cloud PCs Android sont accessibles pour le moment qu'avec un appareil tactile (smartphone ou tablette).",
            "awaitingUserResponse": "En attente de la réponse de {user}...",
            "canDisableInSettings": "(Vous pouvez désactiver cette fonctionnalité dans les paramètres)",
            "changePasswordInSystemPreferences": "Vous pouvez changer votre mot de passe à tout moment dans les préférences de votre système.",
            "clipboardNotSupported": "Le presse-papiers n'est pas supporté par ce navigateur.",
            "clipboardPermissionRequired": "Vous devez autoriser l'accès au presse-papiers pour pouvoir copier et coller du texte.",
            "cloudPcAutoSleepIn": "Votre Cloud PC se mettra en veille automatiquement dans",
            "cloudPcPoweredOff": "La connexion avec votre Cloud PC vient d'être interrompue car il n'est plus en fonctionnement.",
            "connectionDetectionInProgress": "Détection automatique de la connexion en cours...",
            "connectionFailure": "La connexion avec votre Cloud PC vient d'être interrompue à cause d'un problème de réseau.",
            "connectionInterruptedByInactivity": "La connexion avec votre Cloud PC vient d'être interrompue à cause d'inactivité.",
            "controlBeingTransferred": "Le transfert du contrôle est en cours.",
            "controlForciblyLostInfo": "{user} a pris le contrôle de ce Cloud PC.",
            "controlForciblyTaken": "Vous avez pris le contrôle de ce Cloud PC.",
            "controlGained": "Vous avez obtenu le contrôle de ce Cloud PC.",
            "controlPanelDescription": "Quittez le mode plein écran, gérez l'alimentation et bien plus grâce au panneau de contrôle.",
            "controlRegainedReconnecting": "Vous avez repris le contrôle de votre Cloud PC, reconnexion en cours.",
            "controlRequestAccepted": "Votre demande de prise contrôle a été acceptée.",
            "controlRequestCancelled": "Votre demande de contrôle a été annulée.",
            "controlRequestCancelledByUser": "{user} a annulé sa demande de contrôle.",
            "controlRequestExpiredForUser": "La demande de contrôle de {user} a expiré.",
            "controlRequestExpiredRetrying": "Votre demande de contrôle a expiré, nouvelle tentative...",
            "controlRequestNotifiesUserForApproval": "L'utilisateur sera notifié d'une demande de contrôle qu'il pourra accepter ou refuser.",
            "controlRequestRefused": "L'utilisateur a refusé votre demande de prise contrôle.",
            "controlRequestRefusedInfo": "Votre demande de contrôle a été refusée par {user}.",
            "controlRetained": "Vous conservez le contrôle de ce Cloud PC.",
            "controlTransferredTo": "Contrôle transféré à {user}.",
            "controlTransferredToUserInfo": "Le contrôle a été transféré à {user}.",
            "cursorModeExplanation": "En capturant le curseur, les déplacements du curseur sont limités à l'écran de votre Cloud PC.\nEn mode non capturé, le curseur peut passer du Cloud PC aux autres fenêtres de votre environnement local.\nLe mode souris capturée est conseillé pour les jeux ou les applications graphiques.",
            "dataSaved": "Vos données sont sauvegardées.",
            "disconnectedSupervisionRoomEnded": "Vous avez été déconnecté car la session supervisée a pris fin.",
            "doNotShowAgain": "Ne plus afficher ce message",
            "emptyFileTransferNotSupported": "Le fichier {0} n'a pas pu être transféré. Les fichiers vides (0 octet) ne sont pas supportés.",
            "enterKeyboardShortcut": "Appuyez sur 2 touches simultanément pour définir votre nouveau raccourci.",
            "enterSupervisionRoomCode": "Renseignez le code de la salle de supervision",
            "exitFullscreenToReturnToLocalEnvironment": "Pour quitter le mode plein écran et revenir à votre environnement local.",
            "fileTooLargeToTransfer": "Le fichier {0} est trop volumineux pour être transféré (max {1} Mo).",
            "fileTransferredSuccessfully": "Le fichier {0} a été transféré avec succès.",
            "finishingTest": "Finalisation du test...",
            "folderTransferNotSupported": "Le dossier {0} n'a pas pu être transféré. Le transfert de dossier n'est pas supporté. Vous pouvez compresser votre dossier (ZIP, RAR, etc.) pour pouvoir le transférer.",
            "forceControlTakesOverImmediately": "Prendre le contrôle du Cloud PC immédiatement.",
            "fpsOptimizationDescription": "Lorsque l'optimisation vidéo est activée, le nombre d'images par seconde (FPS) envoyées s'adapte aux besoins d'affichage et permet d'économiser les ressources du serveur. Désactivez-la pour forcer une fréquence de rafraîchissement de 60 FPS.",
            "groupSessionNoLongerExists": "La session de groupe n'existe plus.",
            "impossibleToConnect": "Une erreur imprévue est survenue, veuillez redémarrer la connexion. Nous vous invitons à contacter le support si l'erreur persiste.",
            "inactivityRemainingMinutes": "0 minute | 1 minute | {count} minutes",
            "inactivityRemainingSeconds": "0 seconde | 1 seconde | {count} secondes",
            "iosFullscreenAdvice": "Pour profiter pleinement de l'expérience de notre Cloud PC virtuel Android, nous vous conseillons de passer en mode plein écran sur votre appareil iOS.",
            "iosFullscreenHomeScreen": "Une fois l'icône ajoutée à votre écran d'accueil, appuyez dessus pour lancer votre Cloud PC en plein écran.",
            "iosFullscreenShareButton": "Pour cela, appuyez sur le bouton 'Partager' en bas ou en haut de votre écran, puis sur 'Sur l'écran d'accueil'.",
            "machineAlreadyInUseBy": "Ce Cloud PC est déjà utilisé par {user}.",
            "machineBeingTakenOver": "La prise de contrôle du Cloud PC est en cours.",
            "machineEnrolledInSupervisionRoom": "Vous avez rejoint la salle de supervision {supervisionRoom}.",
            "machineLocked": "L'administrateur de la salle de supervision a verrouillé ce Cloud PC.",
            "machineNoLongerInSupervisionRoom": "Cette machine ne fait plus partie de la salle de supervision.",
            "machineUnlocked": "Le Cloud PC a été déverrouillé.",
            "menuShortcutReminder": "Afficher le menu : {0} + {1}",
            "multipleControlRequestsReceived": "{count} utilisateurs souhaitent prendre le contrôle de votre Cloud PC :",
            "putMachineInSleepModeBeforeLeavingQuestion": "Voulez-vous mettre votre Cloud PC en veille avant de quitter ?",
            "rememberToSaveYourWork": "Pensez à sauvegarder votre travail si nécessaire.",
            "resolutionNotSupportedByMachineConfig": "La configuration de ce Cloud PC ne permet pas de définir une résolution spécifique.",
            "roomSupervisorIsViewingYourMachine": "Le superviseur de salle visionne actuellement votre Cloud PC.",
            "roomSupervisorStoppedViewingYourMachine": "Le superviseur de salle a quitté la visualisation de votre Cloud PC.",
            "sessionResumedOnAnotherDevice": "Une nouvelle session a été démarrée sur ce Cloud PC depuis un autre appareil.",
            "shortcutMustContainTwoKeys": "Le raccourci doit contenir 2 touches différentes.",
            "singleControlRequestReceived": "Un utilisateur souhaite prendre le contrôle de votre Cloud PC :",
            "spiceDriverDegradedPerformance": "Les fonctionnalités suivantes de votre Cloud PC sont dégradées car le driver spice-vdagent n'est pas activé :<br>{0}<br>Veuillez contacter le support.",
            "streamPausedWaitingForAdmin": "Le stream est en pause. Il reprendra dès qu'un administrateur se connectera.",
            "supervisedSessionEndsIn": "Votre session supervisée {name} se termine dans {time}.",
            "supervisedUserLeftSupervisionRoom": "Vous ne pouvez plus accéder au Cloud PC de l'utilisateur supervisé car il a quitté la session.",
            "supervisorAllMachinesLocked": "Toutes les machines ont été verrouillées.",
            "supervisorAllMachinesUnlocked": "Toutes les machines ont été déverrouillées.",
            "supervisorMachineLocked": "Le Cloud PC {machine} a été verrouillé.",
            "supervisorMachineUnlocked": "Le Cloud PC {machine} a été déverrouillé.",
            "supportRequestDataInfo": "Certaines informations concernant le compte et le système pourront être envoyées à Weytop. Nous les utiliserons pour résoudre des problèmes et améliorer nos services. Nous pourrons vous demander plus d'informations ou vous en envoyer par e-mail.",
            "supportRequestDescriptionPlaceholder": "Merci de décrire le bug ou la suggestion de façon précise.\n\nEn cas de bug, veuillez détailler la procédure étape par étape, ainsi que le résultat attendu.",
            "supportRequestFeedbackWarning": "Vos commentaires comptent pour nous, attention cependant à ne pas partager d'informations sensibles.",
            "supportRequestSent": "Votre demande de support a été envoyée. Nous reviendrons vers vous dès que possible.",
            "thanks": "Merci !",
            "updateDetectionInProgress": "Détection automatique de la mise à jour en cours...",
            "usbAgentConnecting": "Connexion à l'agent en cours...",
            "usbAgentDisconnected": "L'agent n'est plus connecté, vous ne pouvez plus utiliser vos périphériques USB locaux.",
            "usbAgentError": "Une erreur s'est produite, veuillez réessayer plus tard",
            "usbAgentGuiDisconnected": "Impossible d'obtenir la liste des péripheriques. Êtes-vous connecté à l'Agent Weytop disponible dans la zone de notification de Windows ?",
            "usbAgentNotInstalled": "L'agent USB Weytop n'est pas installé ou n'est pas en cours d'exécution sur votre ordinateur. Installez-le et la connexion sera détectée automatiquement.",
            "usbAgentUpdateDetected": "L'agent a été mis à jour avec succès. Vous disposez désormais de la dernière version.",
            "usbAgentUpdateNotDetected": "La mise à jour de l'agent n'a pas été détectée automatiquement. Veuillez vérifier que la mise à jour est terminée et relancer la connexion.",
            "usbDeviceConnected": "Le périphérique a été connecté à votre Cloud PC.",
            "usbDeviceDisconnected": "Le périphérique a été déconnecté de votre Cloud PC.",
            "usbDeviceError": "Le périphérique n'a pas pu être connecté à votre Cloud PC.",
            "usbDevicePending": "Le périphérique est en cours de connexion.",
            "useMenuToManageCloudPc": "Utilisez le menu pour gérer votre Cloud PC.",
            "userTookControl": "{user} a pris le contrôle de ce Cloud PC.",
            "useSupportedBrowsersForStreaming": "Pour une meilleure expérience utilisateur, utilisez l'un de nos navigateurs supportés :",
            "vdAgentNotAvailable": "Le service VdAgent n'est pas disponible. Le transfert de fichiers n'est pas possible. Veuillez contacter le support.",
            "waitForUnlock": "Veuillez patienter, vous pourrez reprendre son utilisation une fois le verrouillage levé.",
            "webcamConfigError": "Impossible d'accéder à la webcam. Veuillez vérifier les permissions de votre navigateur.",
            "youHaveBeenKickedFromSession": "Vous avez été expulsé de cette session.",
            "youLeftSupervisionRoom": "Vous avez quitté la salle de supervision {supervisionRoom}."
        },
        "title": {
            "aboutToLeaveMachine": "Vous êtes sur le point de quitter votre Cloud PC",
            "accessDenied": "Accès refusé",
            "clipboardUnavailable": "Vous ne pouvez pas copier/coller",
            "cloudPcPoweredOff": "Cloud PC hors tension",
            "connectionInterrupted": "Connexion interrompue",
            "contactSupport": "Contacter le support",
            "controlForciblyLost": "Prise de contrôle forcée",
            "controlRequest": "Demande de contrôle",
            "controlRequestRefused": "Demande de contrôle refusée",
            "controlRequestSent": "Demande de contrôle envoyée",
            "controlTransferredToUser": "Contrôle transféré",
            "errorOccurred": "Une erreur est survenue",
            "groupSession": "Session de groupe",
            "groupSessionEnded": "Fin de la session de groupe",
            "impossibleToConnect": "Connexion impossible",
            "inactivityWarning": "Vous êtes inactif",
            "isoDisks": "Disques ISO",
            "machineAlreadyInUse": "Cloud PC déjà utilisé",
            "machineUnenrolledFromSupervisionRoom": "Cloud PC retiré de la salle de supervision",
            "maintenanceScheduled": "Maintenance planifiée",
            "maintenancesScheduled": "Maintenances planifiées",
            "missingSupervisedUser": "Utilisateur supervisé manquant",
            "networkInfo": "Informations réseau",
            "noAdminInGroupSession": "Aucun administrateur dans la session de groupe",
            "sendCommand": "Envoyer une commande",
            "sessionEndingApproaching": "Fin de session en approche",
            "sessionEndingImminent": "Fin de session imminente",
            "sessionResumedOnAnotherDevice": "Nouvelle session détectée",
            "someTips": "Quelques conseils",
            "someTipsForOptimalExperience": "Quelques conseils pour une expérience optimale",
            "supervisionRoom": "Salle de supervision",
            "supervisionRoomEnded": "Session supervisée terminée",
            "takingControl": "Prise de contrôle en cours",
            "transferringControl": "Transfert du contrôle en cours",
            "webcamConfig": "Configuration de la webcam",
            "webcamConfigError": "Erreur de webcam"
        }
    },
    "compatibilityTest": {
        "browser": "Navigateur",
        "direct": "Accès direct",
        "failure": "Incompatible",
        "loading": "Patientez quelques secondes, le temps de déterminer votre configuration...",
        "os": "Système d'exploitation",
        "quality": "Stabilité de la connexion",
        "quality_labels": ["Mauvaise", "Moyenne", "Bonne"],
        "result": {
            "description": "Renseignez votre email pour recevoir les résultats de votre test et déterminer si vous êtes éligible à l'offre Weytop.",
            "email": "Email",
            "myMail": "Mon email",
            "title": "Recevez vos résultats"
        },
        "sent": {
            "description": "Consultez votre boîte de réception pour prendre connaissance des résultats du test.",
            "title": "Résultats envoyés"
        },
        "serviceStatus": {
            "reachable": "Service accessible",
            "unreachable": "Service inaccessible"
        },
        "skipped": "Ignoré",
        "startBtn": "Commencer le test",
        "streaming": "Streaming",
        "success": "Compatible",
        "title": "Testez votre éligibilité à l'offre Weytop",
        "turn": "Accès TURN"
    },
    "groupSession": {
        "copyLinkSuccess": {
            "content": "Le lien de partage a été copié dans le presse-papier.",
            "title": "Lien de partage copié"
        }
    },
    "handover": {
        "userJoinGroupSession": {
            "message": "{0} a rejoint la session.",
            "title": "Un utilisateur a rejoint la session"
        },
        "userLeftGroupSession": {
            "message": "{0} a quitté la session.",
            "title": "Un utilisateur a quitté la session"
        }
    },
    "pendingTransfer": {
        "end": "Finalisation...",
        "title": "Transferts en cours"
    },
    "player": {
        "browserNotCompatible": "Votre navigateur n'est pas compatible avec Weytop.",
        "cannotConnectRTC": "Impossible d'établir une connexion avec le serveur. Veuillez réessayer plus tard.",
        "compatibleNavigator": "Assurez-vous de mettre à jour votre navigateur ou",
        "downloadLast": "téléchargez la dernière version de Google Chrome.",
        "unstableConnection": "Votre connexion est instable, tentative de reconnexion..."
    },
    "supervisionRoom": {
        "card": {
            "awaitingPreview": "Aperçu en cours de génération...",
            "connect": "Se connecter",
            "isFocused": "Fenêtre active",
            "isNotFocused": "Fenêtre inactive",
            "lock": "Verrouiller",
            "machineOffline": "Cloud PC hors-ligne",
            "machineOut": "A quitté la salle",
            "unlock": "Déverrouiller",
            "usedBy": "Utilisé par",
            "userHasLeft": "Le participant a quitté la salle de supervision",
            "userNotConnected": "Participant non connecté à la salle de supervision",
            "userOffline": "Utilisateur non connecté"
        },
        "enrolledMachines": "Aucun Cloud PC dans la salle de supervision | 1 Cloud PC dans la salle de supervision | {count} Cloud PCs dans la salle de supervision",
        "machines": {
            "lock": "Verrouiller tous les Cloud PCs",
            "unlock": "Déverrouiller tous les Cloud PCs"
        },
        "sort": {
            "default": "Trier par",
            "joinedAsc": "Enrôlé en dernier",
            "joinedDesc": "Enrôlé en premier",
            "nameAsc": "Nom (A-Z)",
            "nameDesc": "Nom (Z-A)"
        }
    }
}
